const API = {
  GET_NEWSFEED: {
    path: '/newsfeed/details/ent/:entId',
    method: 'GET',
  },
  GET_NEWSFEED_BY_EXPERT: {
    path: '/newsfeed/details/expert/:expertId',
    method: 'GET',
  },
  GET_FETCH_NEWSFEEDS: {
    path: '/newsfeed/expert-feed',
    method: 'POST',
  },
  CREATE_NEWSFEED: {
    path: '/newsfeed/create',
    method: 'POST',
  },
  UPDATE_NEWSFEED: {
    path: '/newsfeed/update',
    method: 'POST',
  },
  DELETE_NEWSFEED: {
    path: '/newsfeed/delete',
    method: 'DELETE',
  },
  PIN_NEWSFEED: {
    path: '/newsfeed/pin-newsfeed',
    method: 'POST',
  },
};
export default API;
